import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@dashboard/components/ui/select';

import Label from './Label';

const FilterInput = ({ options, onChange, label, value }) => {
  const keys = Object.keys(options);
  const currentValue = value || keys[0];

  return (
    <div>
      {label && <Label>{label}</Label>}
      <Select value={currentValue} onValueChange={onChange}>
        <SelectTrigger className="w-fit min-w-[8rem]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent position="popper" align="start">
          {keys.map((key, index) => {
            const option = options[key];
            const previousGroup = index > 0 ? options[keys[index - 1]].group : undefined;
            const showSeparator = option.group && previousGroup && option.group !== previousGroup;

            return (
              <React.Fragment key={key}>
                {showSeparator && <SelectSeparator />}
                <SelectItem value={key}>{option.label}</SelectItem>
              </React.Fragment>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
};

export default FilterInput;
